import { ReduxAction } from '../../constants';
const initialState = {};

const userContractsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ReduxAction.userContractsSet: {
      return {
        ...state,
        userContracts: action.payload,
      };
    }
    default:
      return state;
  }
};
export default userContractsReducer;
